import { Shell } from "../../../components/ops/Shell";
import { useAuth } from "../../../context/AuthContext";
import { adminNavItems } from "../adminNav";

export function AdminLayout() {
  const { user, signOut } = useAuth();

  return (
    <Shell
      navItems={adminNavItems}
      brandTitle="Formula Soccer"
      brandSubtitle="Admin Console"
      eyebrow="Admin Console"
      user={user}
      onSignOut={signOut}
    />
  );
}
